<template>
    <el-empty :description="description"></el-empty>
</template>

<script>
export default {
  name: 'NoSiteMap',
  props: {
    description: {
      type: String, default: 'No Facility selected',
    },
    facility: {
      type: String,
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NoSiteMap.vue